import { useEffect } from 'react';

const MicrosoftClarity = () => {
  useEffect(() => {
    const win = /** @type {any} */ (window);

    // Only load in production
    if (process.env.NODE_ENV === 'production') {
      // Initialize Microsoft Clarity
      (function(c,l,a,r,i,t,y){
        c[a] = c[a] || function(){(c[a].q = c[a].q || []).push(arguments)};
        t = l.createElement(r);
        t.async = 1;
        t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t,y);
      })(win, document, "clarity", "script", "rkivjdxele");
    } else {
      // Mock clarity for development
      win.clarity = function() {
        console.log('Microsoft Clarity (development):', ...arguments);
      };
    }
  }, []);

  return null; // This component doesn't render anything
};

export default MicrosoftClarity;